export default __webpack_public_path__ + "static/media/cofee.cbb24237.PNG";